<template>
  <div
    v-loading="posterLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="dilog-box-loading">
    <div class="scale-wrapper" id="scaleWrapper" ref="scaleWrapper">
      <div ref="poster" id="poster" class="poster">
        <img
          src="./../assets/xi_12.jpg"
          alt="Background"
          class="background-image"
          @contextmenu.prevent="handleContextMenu"
        >

        <!-- 文字 -->
        <div class="poster-text">
          <div class="text-1">
            截至{{ formatDate(time) }}
          </div>
          <div :class="name.length>18?'text-2-long':(name.length>12?'text-2-center':'text-2')">
            {{ name }}
          </div>
          <div class="text-3">
            采集总样本量
          </div>
          <div :class="name.length>12?'text-4 text-4-long':'text-4'">
            突破{{ formatNumber(amount) }}<span>份</span>
            </div>
            <div class="poster-text-center_s">
              <div class="text-number">
                <div>主问卷&nbsp;{{ formatNumber_s(rowData.amount) }}<span>{{formatUnit(rowData.amount)}}份</span></div>
                <span>&nbsp;&nbsp;</span>
                <div>专题问卷&nbsp;{{ formatNumber_s(rowData.specialAmount) }}<span>{{formatUnit(rowData.specialAmount)}}份</span></div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <template v-if="isPc">
        <el-button
          type="primary"
          @click="generatePoster"
        >
          保存本地
        </el-button>
      </template>
      <template v-else>
        <el-button
          type="primary"
          @click="openImg"
        >
          保存本地
        </el-button>
      </template>
    </div>
  </div>
</template>

<script>

import html2canvas from 'html2canvas';
export default {
  name: 'CustomButton',
  props: {
    type: {
      type: Number,
      default: 1
    },
    isPc: {
      type: Boolean,
      default: false
    },
    amount: {
      type: Number,
      default: 0
    },
    rowData: {
      type: Object,
      default: {
        amount: 0, // 主问卷总量
        specialAmount: 0, // 主问卷总量
      }
    },
    name: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: () => {} // 默认点击事件为空函数
    }
  },
  data() {
    return {
      posterLoading: false,
      isWechat: /micromessenger/i.test(navigator.userAgent),
    }
  },
  created() {
    this.posterLoading = true;
    setTimeout(() => {
      this.posterLoading = false;
    }, 20);
    console.log('rowData',this.rowData)
  },
  mounted() {
    this.scalePoster();
    window.addEventListener('resize', this.scalePoster);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scalePoster);
  },
  methods: {
    handleContextMenu() {
      // 阻止右键菜单
      return false;
    },
    scalePoster() {
      const wrapper = this.$refs.scaleWrapper;
      if (!wrapper || window.innerWidth > 768) {
        wrapper.style.transform = '';
        return;
      } else if (!wrapper || window.innerWidth > 400) {
        wrapper.style.transform = `scale(0.6)`;
        wrapper.style.transformOrigin = 'center top';
      } else {
        wrapper.style.transform = `scale(0.58)`;
        wrapper.style.transformOrigin = 'center top';
      }
    },
    formatNumber(value) {
      if (value >= 100000) {
        return `${Math.floor(value / 10000)}万`;
      } else if (value >= 10000) {
        return parseInt(value / 1000) * 1000;
      } else if (value >= 1000) {
        return parseInt(value / 100) * 100;
      } else {
        return parseInt(value / 10) * 10;
      }
    },
    // 格式化数值的方法
    formatNumber_s(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.amount >= 100000) {
        return (value / 10000).toFixed(4);
      } else {
        return value;
      }
    },
    formatUnit(value) {
      /* 新增了主问卷和专题问卷的数据，
      全国和超过10万的省份所有数据都以“万”为单位，
      保留小数点后四位，10万以下的省份还是按照原来那样*/
      if(this.name === '全国' || this.amount >= 100000) {
        return '万';
      } else {
        return '';
      }
    },
    handleImageLoad(event) {
      console.log('图片加载完成', event);
      this.posterLoading=false;
      // 执行图片加载完成后的逻辑
    },
    handleImageError(event) {
      console.log('图片加载失败', event);
      // 处理图片加载失败的逻辑
    },
    handleClick() {
      // 调用传入的点击事件处理器
      this.onClick();
    },
    openImg() {
      this.$nextTick(async () => {
        try {
          // 截图，scale 设为 3 提高分辨率
          const canvas = await html2canvas(this.$refs.scaleWrapper, {
            useCORS: true,
            backgroundColor: null,
            scale: 3,
          });

          // 生成预览
          const dataURL = canvas.toDataURL('image/png');
          this.previewImage(dataURL);
        } catch (err) {
          this.$message.error('生成图片失败');
        }
      });
    },
    previewImage(src) {
      // 方案1：弹层预览（推荐）
      document.body.style.overflow = 'hidden';
      const mask = document.createElement('div');
      mask.style.cssText = `
        position:fixed;right:0;bottom:0;inset:0;background:rgba(0,0,0,.85);
        display:flex;align-items:center;justify-content:center;
        z-index:9999;user-select:none;
      `;
      const img = document.createElement('img');
      img.src = src;
      img.style.cssText = `max-width:90%;max-height:90%;border-radius:8px;`;
      mask.appendChild(img);
      // 点空白关闭
      mask.addEventListener('click', () => document.body.removeChild(mask));
      document.body.appendChild(mask);
    },
    generatePoster() {
      this.$nextTick(()=>
      {
        if(this.$refs.scaleWrapper.id == 'scaleWrapper') {
          const posterElement = this.$refs.scaleWrapper;
          html2canvas(posterElement, {
            useCORS: true, // 解决跨域问题
            scale: 3, // 提高分辨率
          }).then(canvas=> {
            const posterImage = canvas.toDataURL('image/png', 1.0);
            // 在这里你可以保存或显示生成的海报图像
            // 如果要保存为文件，可以创建一个下载链接
            const link = document.createElement('a');
            link.href = posterImage;
            link.download = `${this.name}-${this.amount}喜报.png`;
            link.click();
          });
        }else {
          this.$message.error('请稍后再试！！！');
        }
      })

    },
    formatDate(dateString) {
      // 将日期字符串转换为Date对象
      const dateStr = dateString.replace(/-/g,"/");
      const date = new Date(dateStr);

      // 获取月、日、小时、分钟
      const month = date.getMonth() + 1; // getMonth() 返回的月份是从0开始的
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();

      // 格式化月、日、小时、分钟（补零）
      const monthStr = month < 10 ? `0${month}` : `${month}`;
      const dayStr = day < 10 ? `0${day}` : `${day}`;
      const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
      const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;

      // 拼接格式化后的日期字符串
      return `${monthStr}月${dayStr}日 ${hoursStr}:${minutesStr}`;
      // return `${date}`;
    }
  }
};
</script>

<style scoped>
.dilog-box-loading {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content:center;
}
.poster {
  padding: 0;
  margin: 0;
  position: relative;
  width: 540px;
  height: 960px;
  color: rgb(239, 81, 80);
}
.background-image {
  width: 100%;
  height: 100%;
}

.poster-text {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translateX(-50%);
  width: 84%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.poster-text .text-1 {
  font-family: CustomFont6;
  color: #FE4B4C;
  letter-spacing: 1px;
  font-size: 15px;
  line-height: 22px;
}
.poster-text .text-2 {
  width: 100%;
  font-family: CustomFont5;
  color: #DA2618;
  font-size: 34px;
  line-height: 48px;
  text-align: center;
  margin-bottom: 4px;
}
.poster-text .text-2-center {
  width: 74%;
  font-family: CustomFont5;
  color: #DA2618;
  font-size: 34px;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 4px;
}
.poster-text .text-2-long {
  width: 98%;
  font-family: CustomFont5;
  color: #DA2618;
  font-size: 34px;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 4px;
}
.poster-text .text-3 {
  font-family: CustomFont5;
  color: #EF5150;
  font-size: 26px;
  text-align: center;
}
.poster-text .text-4 {
  font-style: italic;
  font-family: CustomFont7;
  font-size: 64px;
  color: #FFEC9F;
  text-shadow:
     1px  1px 0 #EB3C36,
     1px -1px 0 #EB3C36,
    -1px  1px 0 #EB3C36,
    -1px -1px 0 #EB3C36,
     0    1px 0 #EB3C36,
     0   -1px 0 #EB3C36,
     1px  0   0 #EB3C36,
    -1px  0   0 #EB3C36,
    4px 4px 0px #C74328;
    margin: 3.8% auto;
}
.poster-text .text-4-long {
  margin: 2.8% auto;
}
.text-4-long span, .text-4 span {
  font-size: 28px;
  text-shadow:
     1px  1px 0 #EB3C36,
     1px -1px 0 #EB3C36,
    -1px  1px 0 #EB3C36,
    -1px -1px 0 #EB3C36,
     0    1px 0 #EB3C36,
     0   -1px 0 #EB3C36,
     1px  0   0 #EB3C36,
    -1px  0   0 #EB3C36,
    4px 5px 0px #C74328;
}
.poster-text-center_s-long {
  width: 86%;
  text-align: center;
  font-family: CustomFont5;
}
.poster-text-center_s {
  width: 86%;
  text-align: center;
  font-family: CustomFont5;
}
.poster-text-center_s-long .text-number, .poster-text-center_s .text-number {
  font-size: 16px;
  display: flex;
  justify-content: center;
}
.btn-box {
  margin-top: 20px;
}
@media screen and (max-width: 768px) {
  .btn-box {
    margin-top: calc( -960px * 0.39 );
  }
}

@media screen and (max-width: 400px) {
  .btn-box {
    margin-top: calc( -960px * 0.40 );
  }
}
</style>



// WEBPACK FOOTER //
// src/components/poster.vue